
/**
 * First, we will load all of this project's Javascript utilities and other
 * dependencies. Then, we will be ready to develop a robust and powerful
 * application frontend using useful Laravel and JavaScript libraries.
 */

require('./bootstrap');
// require('./vivus.min.js');
require('./cookieconsent');

function isValidEmail(str) {
	var regx = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[^\.!#$%&'*+\/=?^`{|}~\s]+(\.[^!#$%&'*+\/=?^`.{|}~\s]+)+$/;
	return regx.test(str);
}

function sleep(milliseconds) {
  var start = new Date().getTime();
  for (var i = 0; i < 1e7; i++) {
    if ((new Date().getTime() - start) > milliseconds){
      break;
    }
  }
}

// TextSlide
var header = document.getElementById("textSlide");
var btns = header.getElementsByClassName("btn");

for (var i = 0; i < btns.length; i++) {
  btns[i].addEventListener("click", function() {
    var current = document.getElementsByClassName("active");
    current[0].className = current[0].className.replace(" active", "");
    this.className += " active";

    var textboxID = this.getAttribute('id');
    textboxID = '[data-id="' + textboxID + '"]';
    var boxcurrent = $(textboxID);
    var textboxes = header.getElementsByClassName('text-box active');
    textboxes[0].className = textboxes[0].className.replace(" active", "");
    boxcurrent[0].className += " active";
  });
}

var btnSubmit = document.getElementById("submit");

btnSubmit.addEventListener("click", function(evt) {

  document.getElementById('formAlerts').innerHTML = '';
  document.getElementById('formAlerts').className = "animated";
  document.getElementById("mailForm").className = "go-bottom animated";

  if(document.mailForm.subject.value == "") {
  	document.getElementById('submit').innerHTML = '<span class="error animated fadeIn">Das Feld  "Betreff"  muss ausgef\u00fcllt werden!</span>';
    document.mailForm.subject.focus();
    document.getElementById("mailForm").className = "go-bottom animated bounce";
    setTimeout(function(){
      document.getElementById('submit').innerHTML = '<span class="animated fadeIn">Anfrage senden</span>';
    }, 6000);
    evt.preventDefault();
    return false;
  }

  if(document.mailForm.company.value == "") {
  	document.getElementById("submit").innerHTML = '<span class="error animated fadeIn">Das Feld  "Name oder Firma"  muss ausgef\u00fcllt werden!</span>';
    document.mailForm.company.focus();
    document.getElementById("mailForm").className = "go-bottom animated bounce";
    setTimeout(function(){
      document.getElementById('submit').innerHTML = '<span class="animated fadeIn">Anfrage senden</span>';
    }, 6000);
    evt.preventDefault();
    return false;
  }

  if(document.mailForm.email.value == "") {
  	document.getElementById("submit").innerHTML = '<span class="error animated fadeIn">Das Feld  "E-Mail"  muss ausgef\u00fcllt werden!</span>';
    document.mailForm.email.focus();
    document.getElementById("mailForm").className = "go-bottom animated bounce";
    setTimeout(function(){
      document.getElementById('submit').innerHTML = '<span class="animated fadeIn">Anfrage senden</span>';
    }, 6000);
    evt.preventDefault();
    return false;
  }

  if(document.mailForm.note.value == "") {
    document.getElementById("submit").innerHTML = '<span class="error animated fadeIn">Das Feld  "Nachricht"  muss ausgef\u00fcllt werden!</span>';
    document.mailForm.note.focus();
    document.getElementById("mailForm").className = "go-bottom animated bounce";
    setTimeout(function(){
      document.getElementById('submit').innerHTML = '<span class="animated fadeIn">Anfrage senden</span>';
    }, 6000);
    evt.preventDefault();
    return false;
  }

  if (!isValidEmail(document.mailForm.email.value) ) {
  	document.getElementById("submit").innerHTML = '<span class="error animated fadeIn">Bitte kontrollieren Sie Ihre Email-Adresse!</span>';
    document.mailForm.email.focus();
    document.getElementById("mailForm").className = "go-bottom animated bounce";
    setTimeout(function(){
      document.getElementById('submit').innerHTML = '<span class="animated fadeIn">Anfrage senden</span>';
    }, 6000);
    evt.preventDefault();
    return false;
  }

  // var fields = $( "#mailForm input, #mailForm textarea" ).serializeArray();
  //
  // subject = fields[0];
  // company = fields[1];
  // email = fields[2];
  // note = fields[3];
  //
  // $.ajax({
  //     data: {
  //       subject: subject,
  //       company: company,
  //       email: email,
  //       note: note
  //     },
  //     url: '/sendmail',
  //     type: 'POST',
  //     beforeSend: function (request) {
  //         return request.setRequestHeader('X-CSRF-Token', $("meta[name='csrf-token']").attr('content'));
  //     },
  //     success: function(response){
  //       console.log(response.alerts);
  //       document.getElementById("mailForm").className = "go-bottom animated jackInTheBox";
  //       document.getElementById("submit").innerHTML = response.alerts;
  //       setTimeout(function(){
  //         // document.getElementById('mailForm').className = "go-bottom animated fadeIn";
  //         setTimeout(function(){
  //           document.getElementById('mailForm').className = "go-bottom animated bounceIn";
  //           var clean_fields = $( "#mailForm input, #mailForm textarea" ).val('');
  //           document.getElementById('submit').innerHTML = '<span class="animated fadeIn">Anfrage senden</span>';
  //         }, 6000);
  //       }, 2000);
  //
  //     },
  //     error: function (xhr, ajaxOptions, thrownError) {
  //       console.log(xhr.status);
  //       console.log(thrownError);
  //   }
  // });
});

function loadGAonConsent(){
	window.ga=window.ga||function(){(ga.q=ga.q||[]).push(arguments)};ga.l=+new Date;
	ga('create', 'UA-126060802-1', 'auto');
	ga('set', 'anonymizeIp', true);
	ga('send', 'pageview');
	var gascript = document.createElement("script");
	gascript.async = true;
	gascript.src = "https://www.google-analytics.com/analytics.js";
	document.getElementsByTagName("head")[0].appendChild(gascript, document.getElementsByTagName("head")[0]);
}

if (document.cookie.split(';').filter(function(item) {
	return item.indexOf('cookieconsent_status=allow') >= 0
	}).length) {
	if (navigator.doNotTrack != 1 && navigator.doNotTrack != "yes" && window.doNotTrack != 1 && navigator.msDoNotTrack != 1) {
		loadGAonConsent();
	}
}

window.addEventListener("load", function(){
	window.cookieconsent.initialise({
		"palette": {
			"popup": {
				"background": "#404040"
			},
			"button": {
				"background": "#ffffff"
			}
		},
		"position": "bottom-right",
		"type": "opt-out",
		"content": {
			"message": "Ich nutze Cookies und Google Analytics, um diese Website für Sie so interessant wie möglich zu gestalten. Sind Sie damit einverstanden? (Sie können diese Entscheidung jederzeit widerrufen)",
			"allow": "Einverstanden",
			"deny": "keine Cookies",
			"link": "Datenschutzerklärung",
			"href": "https://webdesign.schibalsky.net/impressum"
		},
		onStatusChange: function(status, chosenBefore) {
			var type = this.options.type;
			var didConsent = this.hasConsented();
			if (type == 'opt-in' && didConsent) {
				loadGAonConsent();
			}
		},
		onPopupClose: function() {
			location.reload();
		}
	})
});



// WEBPACK FOOTER //
// ./resources/js/app.js